var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-name" }, [
          _c("h2", { attrs: { id: "benefitHeader" } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.pageTitle) +
                "\n                "
            ),
            _c(
              "button",
              {
                staticClass: "back_button btn btn-primary pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Back")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "form",
            { attrs: { id: "changeProfile" } },
            [
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "v-select",
                      {
                        attrs: {
                          name: "locationId",
                          id: "locationId",
                          label: "text",
                          filterable: false,
                          options: _vm.locationArr,
                          placeholder: "Select State"
                        },
                        on: {
                          change: _vm.changedValue,
                          input: function($event) {
                            return _vm.changedValueLocation()
                          },
                          search: _vm.onSearchLocation
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(option.text) +
                                      "\n                                "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "selected-option",
                            fn: function(option) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "selected d-center" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(option.text) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                                Search State...\n                            "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.locationError))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        name: "roleId",
                        id: "roleData",
                        label: "text",
                        searchable: false,
                        filterable: false,
                        options: _vm.roleArr,
                        placeholder: "Select Role"
                      },
                      on: {
                        input: function($event) {
                          return _vm.changedValueRole()
                        }
                      },
                      model: {
                        value: _vm.roleId,
                        callback: function($$v) {
                          _vm.roleId = $$v
                        },
                        expression: "roleId"
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.roleError))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        name: "status",
                        id: "status",
                        label: "text",
                        filterable: false,
                        options: _vm.statusArr,
                        placeholder: "Select Status"
                      },
                      on: {
                        input: function($event) {
                          return _vm.changeStatus()
                        }
                      },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.statusError))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "description" } }, [
                      _vm._v("Description")
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.description,
                          expression: "description"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "description",
                        placeholder: "Description"
                      },
                      domProps: { value: _vm.description },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.description = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.descriptionError))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              [
                _c(
                  "div",
                  { attrs: { id: "app" } },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("vue-dropzone", {
                      ref: "dropzone",
                      attrs: {
                        id: "drop1",
                        options: _vm.dropzoneOptions,
                        destroyDropzone: false,
                        headers: _vm.dropzoneOptions.headers,
                        name: "file"
                      },
                      on: {
                        "vdropzone-removed-file": _vm.removedSelectedFile,
                        "vdropzone-success": _vm.vfileSuccess,
                        "vdropzone-duplicate-file": _vm.vduplicateFile
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.imageError))
                    ]),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _c("strong", {
                        staticClass: "error text-danger",
                        attrs: { id: "errorMsg2" }
                      })
                    ])
                  ],
                  1
                )
              ],
              _vm._v(" "),
              _c("div", {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: { id: "addBenifitBtn", type: "submit", value: "Save" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.AddUpdateWlnessSlider()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    type: "submit",
                    value: "Save and Continue"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.AddUpdateWlnessSlider(
                        (_vm.flag = "Save and Continue")
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "back_button btn btn-primary",
                  attrs: {
                    id: "CancelBenifit",
                    type: "submit",
                    value: "Cancel"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("app-backend-footer")
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "locationId" } }, [
      _vm._v("State"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "roleData" } }, [
      _vm._v("Role"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "status" } }, [
      _vm._v("Status"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "drop1" } }, [
      _vm._v("Upload Image"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f07192e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f07192e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/wellnessslider/AddWellnessSlider.vue
// module id = null
// module chunks = 